import request from '@/utils/request'

const BASE_URL = process.env.VUE_APP_API_BASE_URL


export async function getReleaseNpsDetail(data) {
    return request({
        url: `${BASE_URL}applet/v2/nps/get_release_nps_detail`,
        method: 'post',
        data
    })
}

export async function getReleaseNpsAnswer(data) {
    return request({
        url: `${BASE_URL}applet/v2/nps/get_release_nps_answer`,
        method: 'post',
        data
    })
}

export async function saveNpsAnswer(data) {
    return request({
        url: `${BASE_URL}applet/v2/nps/save_nps_answer`,
        method: 'post',
        data
    })
}